import * as THREE from 'three';
import {RoomPlannerProductWithTemplate} from 'components/customer/RoomPlanner/types';

// Helper function to calculate display height
export const calculateDisplayHeight = (
    cabinetGroup: THREE.Group,
    cabinetValues: RoomPlannerProductWithTemplate
): number => {
    const extendOnFloor = Number(cabinetValues.cabinet_extend) || 0;
    const cabinetToekick = Number(cabinetValues.toe_kick_height) || 0;
    const updatedToeKickHeight = Number(cabinetValues.cabinet_toekick) || 0;
    const cabinetHeight = Number(cabinetValues.cabinet_height) || 0;

    const shouldAddToeKick =
        Boolean(extendOnFloor) &&
        (Boolean(cabinetGroup.userData.isPanelProduct) ||
            Boolean(cabinetGroup.userData.isFillerProduct));

    const toeKickHeight = shouldAddToeKick
        ? updatedToeKickHeight > 0
            ? updatedToeKickHeight
            : cabinetToekick
        : 0;
    return cabinetHeight + toeKickHeight;
};
